<template>
  <Modal ref="modal" :tiny="true" :close-button="false">
    <h3>{{ $t('deleteFieldModal.title') }}</h3>
    <p>
      {{ $t('deleteFieldModal.content', { name: field.name }) }}
    </p>
    <div class="actions margin-bottom-0">
      <ul class="action__links">
        <li>
          <a @click.prevent="hide">{{ $t('action.cancel') }}</a>
        </li>
      </ul>

      <Button
        type="danger"
        :loading="loading"
        :disabled="loading"
        @click.prevent="confirm"
      >
        {{ $t('deleteFieldModal.confirm') }}</Button
      >
    </div>
  </Modal>
</template>

<script>
import modal from '@baserow/modules/core/mixins/modal'
import Modal from '@baserow/modules/core/components/Modal'

export default {
  name: 'DeleteFieldModal',
  components: {
    Modal,
  },
  mixins: [modal],
  props: {
    field: {
      type: Object,
      required: true,
    },
    loading: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  emits: ['confirm'],
  methods: {
    confirm() {
      this.$emit('confirm')
    },
  },
}
</script>
